import { render, staticRenderFns } from "./Embed.vue?vue&type=template&id=5d3fae4b&scoped=true"
import script from "./Embed.vue?vue&type=script&lang=js"
export * from "./Embed.vue?vue&type=script&lang=js"
import style0 from "./Embed.vue?vue&type=style&index=0&id=5d3fae4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3fae4b",
  null
  
)

export default component.exports